/**
 * Recharts can't read CSS variables, so chart strokes/fills are resolved to the same
 * values the design tokens declare in index.css. Kept in a `.ts` (not the chart `.tsx`)
 * because hex is lint-forbidden in `.tsx` — mirrors the proposals `chartColors.ts`.
 * Keep in lockstep with index.css.
 */
export const CONTRACT_CHART_COLORS = {
  brand: "#0994f2", // --cinch-brand — monthly billed line/area
  gridLine: "hsl(0 0% 88%)",
  term: "#9c27b0", // purple — term / renewal boundary (matches the Cinch chart)
  upsell: "#2e7d32", // green — an upsell amendment first bills
  previous: "hsl(215 16% 47%)", // muted — Previous-Contract (PC) lead-in columns
} as const;
